import {useEffect, useState} from "react";
import liff from "@line/liff";

interface useLineLoginProps {
  liffId: string;
}

export const useLineLogin = ({
  liffId
}: useLineLoginProps) => {
  const [lineUserId, setLineUserId] = useState<string>('');
  const [lineUserName, setLineUserName] = useState<string>('');
  const [lineProfilePic, setLineProfilePic] = useState<string>('');
  const [lineIdToken, setLineIdToken] = useState<string>('');

  const initializeLiff = async () => {
    try {
      await liff.init({ liffId });

      if (!liff.isLoggedIn()) {
        liff.login(); // Redirects user to LINE login
      } else {
        const profile = await liff.getProfile();
        const idToken = liff.getIDToken();

        localStorage.setItem('lineToken', idToken);
        setLineUserId(profile.userId);
        setLineUserName(profile.displayName);
        setLineProfilePic(profile.pictureUrl);
        setLineIdToken(idToken);
      }
    } catch (error) {
      console.error("LIFF Initialization failed:", error);
    }
  };

  useEffect(() => {
    if (liffId) {
      initializeLiff();
    }
  }, [liffId]);

  return { lineUserId, lineUserName, lineProfilePic, lineIdToken };
}

